import firebase from 'firebase/compat/app';
import STORE_CONSTANTS from '../constants';

const AUTO_INVITE_DOC = 'autoInvite';

const converter = {
  toFirestore(
    config: DriverBonusSettings.AutoInviteConfig,
  ): firebase.firestore.DocumentData {
    return config;
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot,
    options: firebase.firestore.SnapshotOptions,
  ): DriverBonusSettings.AutoInviteConfig {
    const data = snapshot.data(options);
    return data as DriverBonusSettings.AutoInviteConfig;
  },
};

const getAutoInviteSettingsRef = ({
  accountId,
  db,
}: {
  accountId: string;
  db?: firebase.firestore.Firestore;
}) => {
  return (db ? db : firebase.firestore())
    .collection('accounts')
    .doc(accountId)
    .collection(STORE_CONSTANTS.DRIVER_BONUS_SETTINGS_COLLECTION)
    .doc(AUTO_INVITE_DOC)
    .withConverter(converter);
};

export default getAutoInviteSettingsRef;
